<button class="btn btn-lg btn-primary btn-block text-white" (click)="redirectToExternalProvider()" role="button" tabindex="0">
  <i class="fas fa-sign-in-alt"></i> {{getButtonLabel() | translate}}
</button>
